import React, { useContext } from 'react';
import { purify } from '../../utils/helpers';
import { Type } from '@spotify-internal/encore-web';
import DeviceContext from '../../../configuration/context/device';

export type LegalTermsType = {
  text: string;
  className?: string;
};

function LegalTerms(props: LegalTermsType) {
  const { className } = props;
  let { text = '' } = props;

  const device = useContext(DeviceContext);

  const targetRegex = /href="([^"]*)"/gim;

  if (device.platform === 'android') {
    text = text.replace(targetRegex, (_target, match) => {
      // only append plain to legal related URLs
      return match.includes('/legal/')
        ? `href="${match}${match.endsWith('/') ? '' : '/'}plain/"`
        : `href="${match}"`;
    });
  }

  if (device.platform === 'ios') {
    text = ``;
  }

  return (
    <Type.p
      className={className}
      variant="finale"
      dangerouslySetInnerHTML={{
        __html: purify(text),
      }}
    />
  );
}

export default LegalTerms;
